import { createAsyncThunk } from "@reduxjs/toolkit";
import { getMaintenanceDataApi, scheduleMaintenanceApi } from "../../apis/maintenanceApis";
import { MaintenanceTypePayload } from "../../commonTypes/maintenanceTypes";

export const scheduleMaintenanceAction = createAsyncThunk(
  'maintenance/schduleMaintenance',
  async (data: MaintenanceTypePayload) => {
    const response = await scheduleMaintenanceApi(data);
    return response.data;
  }
);

export const getMaintenanceDataAction = createAsyncThunk(
  'maintenance/getMaintenanceData',
  async () => {
    const response = await getMaintenanceDataApi();
    return response.data;
  }
);